import script from "./vaccinazioniModalHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./vaccinazioniModalHeader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__